/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';

/**
 * Recalculate every bank account balance.
 */

export function recalculateBalances(client: AxiosInstance): Promise<any> {
  return client.post(resolveAppUrl('bankAccountRecalculateBalances')).then(({ data }) => data);
}

/**
 * Export `useRecalculateBalances`.
 */

export function useRecalculateBalances() {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async () => {
      return await recalculateBalances(client);
    }
  });
}
